<div class="w-full h-full p-2 flex flex-col gap-4">
    <div class="w-full flex flex-col gap-2 bg-white p-2 shadow-md">
        <div class="text-lg">{{ 'ResellerAdminPanel.Search' | translate }}</div>
        <hr>
        <div class="flex flex-col gap-2">
            <div class="flex flex-row flex-wrap items-end gap-2">
                <div class="flex flex-col gap-1">
                    <div>{{ 'ResellerAdminPanel.SearchBy' | translate }}</div>
                    <div class="flex flex-row flex-wrap gap-1">
                        <button *ngFor="let option of searchOptions" (click)="searchType = option.value"
                            class="h-9 px-3 rounded-md border" [ngClass]="option.value === searchType
                                ? 'bg-tachosafe-500 text-white border-tachosafe-500'
                                : 'bg-white text-gray-700 border-gray-300'">
                            {{ option.label }}
                        </button>
                    </div>
                </div>
                <div class="flex flex-col gap-1 flex-1 min-w-[200px]">
                    <div>{{ 'ResellerAdminPanel.Value' | translate }}</div>
                    <input [(ngModel)]="searchText" (keyup.enter)="onSearch()" [minlength]="minChars"
                        class="border border-gray-300 p-1 rounded-md h-9">
                </div>
                <button class="bg-tachosafe-500 h-9 px-4 py-1 text-white text-center rounded-md disabled:opacity-50"
                    [disabled]="searchText.trim().length < minChars" (click)="onSearch()">{{ 'ResellerAdminPanel.Search'
                    | translate }}</button>
            </div>
            <div class="text-xs text-gray-500">{{ 'ResellerAdminPanel.MinCharacters' | translate:{ count: minChars } }}
            </div>
        </div>
    </div>

    <div class="w-full flex flex-col gap-2 bg-white p-2 shadow-md">
        <div class="flex justify-center m-6" *ngIf="loading">
            <div class="w-8 h-8 border-4 border-gray-300 border-t-tachosafe-500 rounded-full animate-spin"></div>
        </div>
        <div class="text-red-600" *ngIf="error">{{ error }}</div>
        <table *ngIf="!loading && results.length > 0" class="w-full text-left border-collapse">
            <thead>
                <tr class="border-b">
                    <th class="p-2 cursor-pointer select-none" (click)="sortBy('itemLabel')">
                        {{ 'ResellerAdminPanel.Name' | translate }}<span *ngIf="sortColumn === 'itemLabel'"> {{ sortAsc
                            ? '▲' : '▼' }}</span>
                    </th>
                    <th *ngIf="hasDetails" class="p-2 cursor-pointer select-none" (click)="sortBy('itemDetails')">
                        {{ detailsHeader }}<span *ngIf="sortColumn === 'itemDetails'"> {{ sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th class="p-2 cursor-pointer select-none" (click)="sortBy('companyName')">
                        {{ 'ResellerAdminPanel.Company' | translate }}<span *ngIf="sortColumn === 'companyName'"> {{
                            sortAsc ? '▲' : '▼' }}</span>
                    </th>
                    <th class="p-2 cursor-pointer select-none" (click)="sortBy('companyPath')">
                        {{ 'ResellerAdminPanel.Hierarchy' | translate }}<span *ngIf="sortColumn === 'companyPath'"> {{
                            sortAsc ? '▲' : '▼' }}</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of results" class="border-b cursor-pointer hover:bg-gray-100"
                    (click)="onRowClick(row)">
                    <td class="p-2">{{ row.itemLabel }}</td>
                    <td *ngIf="hasDetails" class="p-2">{{ row.itemDetails }}</td>
                    <td class="p-2">{{ row.companyName }}</td>
                    <td class="p-2 text-gray-500">{{ row.companyPath }}</td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="!loading && searched && !error && results.length === 0" class="p-2">{{
            'ResellerAdminPanel.NoResults' | translate }}</div>
    </div>
</div>